(function() {
  var map;
  function initialize() {
    var mapOptions = {
      zoom: 16,
      center: new google.maps.LatLng(43.551472,-80.263490),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false
    };
    map = new google.maps.Map(document.getElementById('map'),
        mapOptions);

    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(43.551472,-80.258490),
      map: map,
      title: "ThreeFortyNine Coworking"
    });

    var infowindow = new google.maps.InfoWindow({
      content: '<h2>ThreeFortyNine Coworking</h2>'
    });

    google.maps.event.addListener(marker, 'click', function() {
      infowindow.open(map,marker);
    });
  }

  google.maps.event.addDomListener(window, 'load', initialize);
})();
